import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import SEO from "@/components/SEO";
import { Button } from "@/components/ui/button";

export default function InspectionReadinessPage() {
  return (
    <>
      <SEO
        title="Inspection Readiness Support for Regulated Labs | LabComplyx"
        description="Be continuously inspection-ready with LabComplyx. Organize documentation, close gaps, and prepare your lab for CLIA, CAP, ISO 17025, or FDA audits before inspectors arrive."
        canonical="https://labcomplyx.com/solutions/inspection-readiness"
        breadcrumbs={[
          { name: "Home", url: "https://labcomplyx.com/" },
          { name: "Solutions", url: "https://labcomplyx.com/solutions" },
          { name: "Inspection Readiness", url: "https://labcomplyx.com/solutions/inspection-readiness" },
        ]}
      />
      <div className="pt-24">
        <section className="pb-16 bg-background">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 max-w-2xl">
            <span className="inline-block text-xs font-semibold text-secondary bg-secondary/10 px-3 py-1 rounded-full mb-4">Solution</span>
            <h1 className="text-4xl sm:text-5xl font-bold text-foreground mb-5">Be inspection-ready — before the call comes</h1>
            <p className="text-lg text-muted-foreground leading-relaxed mb-8">
              LabComplyx helps regulated labs organize the documentation work that matters before auditors arrive — closing gaps, aligning records, and building the evidence package that withstands scrutiny.
            </p>
            <Link to="/ValidationIntake"><Button size="lg" className="gap-2">Start Your Inspection Readiness Review <ArrowRight className="w-4 h-4" /></Button></Link>
          </div>
        </section>

        <section className="py-16 bg-muted/30 border-y border-border">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-12">
              <div>
                <h2 className="text-2xl font-bold text-foreground mb-5">What inspectors look for first</h2>
                <ul className="space-y-2.5">
                  {["SOP currency and version control", "CAPA open items and effectiveness checks", "Competency assessment records (CLIA)", "Method validation documentation", "Corrective action closure timelines", "Audit trail completeness and integrity"].map((b) => (
                    <li key={b} className="flex items-start gap-2.5 text-sm text-muted-foreground"><span className="w-1.5 h-1.5 rounded-full bg-destructive shrink-0 mt-1.5" />{b}</li>
                  ))}
                </ul>
              </div>
              <div className="bg-card border border-border rounded-xl p-7">
                <h3 className="font-semibold text-foreground mb-4">LabComplyx inspection readiness approach</h3>
                <ul className="space-y-2.5">
                  {["Gap analysis mapped to your specific regulation (CLIA, CAP, ISO 17025)", "Prioritized documentation remediation plan", "Evidence package organization and indexing", "Pre-inspection mock audit support", "Ongoing readiness monitoring and alerts"].map((b) => (
                    <li key={b} className="flex items-start gap-2.5 text-sm text-muted-foreground"><Check className="w-4 h-4 text-secondary shrink-0 mt-0.5" />{b}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}